import React, { useState, useEffect } from 'react'
import SideBar from '../components/SideBar'
import DetailsHeaderBar from '../components/DetailsHeaderBar'
import DetailSection from '../components/DetailSection'
import { useNavigate, useParams } from 'react-router-dom'
import { MdOutlineImage } from "react-icons/md";
import { TbCategory, TbCategory2 } from 'react-icons/tb'
import { categoryService } from '../services/categoryService';

function SubCategoryDetails() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [subcategory, setSubcategory] = useState(null);
    const [loading, setLoading] = useState(true);
    const [previewImage, setPreviewImage] = useState(null);

    useEffect(() => {
        if (id) {
            fetchSubcategoryDetails();
        }
    }, [id]);

    const fetchSubcategoryDetails = async () => {
        try {
            setLoading(true);
            const response = await categoryService.getSubcategory(id);
            
            if (response && response.subcategory) {
                const formattedSubcategory = {
                    id: response.subcategory.id,
                    name: response.subcategory.name,
                    slug: response.subcategory.slug,
                    description: response.subcategory.description,
                    thumbnail: response.subcategory.image_url || "https://i.pinimg.com/originals/ec/99/db/ec99dbf221d03cf3c93ea8c0336501a1.jpg",
                    images: response.subcategory.image_url ? [response.subcategory.image_url] : [],
                    status: response.subcategory.status,
                    category_id: response.subcategory.category_id,
                    category_master_id: response.subcategory.category_master_id,
                    category_master_name: response.subcategory.category_master_name, // Add this
                    created_by: response.subcategory.created_by,
                    created_at: response.subcategory.created_at,
                    updated_at: response.subcategory.updated_at,
                    meta_title: response.subcategory.meta_title,
                    meta_description: response.subcategory.meta_description,
                    meta_keywords: response.subcategory.meta_keywords || [],
                    created_by_user: response.subcategory.created_by_user,
                    image_url: response.subcategory.image_url,
                    product_count: response.subcategory.product_count,
                    category: response.subcategory.category,
                    products: response.subcategory.products || []
                };
                
                setSubcategory(formattedSubcategory);
            } else {
                setSubcategory(null);
            }
        } catch (error) {
            console.error('Failed to fetch subcategory details:', error);
            setSubcategory(null);
        } finally {
            setLoading(false);
        }
    };

    const goToEdit = () => {
        navigate(`/subcategory-edit/${id}`);
    };

    const handleDelete = async () => {
        if (window.confirm('Are you sure you want to delete this subcategory?')) {
            try {
                await categoryService.deleteSubcategory(id);
                alert('Subcategory deleted successfully');
                navigate('/manage-subcategory');
            } catch (error) {
                alert(error.response?.data?.message || 'Failed to delete subcategory');
            }
        }
    };

    const handleStatusChange = async (newStatus) => {
        try {
            await categoryService.updateSubcategoryStatus(id, newStatus);
            alert(`Subcategory ${newStatus === 'active' ? 'activated' : 'deactivated'} successfully`);
            fetchSubcategoryDetails();
        } catch (error) {
            alert(error.response?.data?.message || 'Failed to update status');
        }
    };

    const getProductImages = () => {
        if (!subcategory || !subcategory.image_url) return [];
        return [subcategory.image_url];
    };

    if (loading) {
        return (
            <div className="manage-member-layout">
                <SideBar />
                <div className="product-details-main">
                    <DetailsHeaderBar
                        title="Subcategory Details"
                        subtitle="You can view the subcategory details"
                        breadcrumbs={[
                            {label: "Home", path: "/manage-member"},
                            {label: "Manage Subcategory", path: "/manage-subcategory"},
                            {label: "Subcategory Details" }
                        ]}
                    />
                    <div style={{textAlign: 'center', padding: '50px'}}>Loading...</div>
                </div>
            </div>
        );
    }

    if (!subcategory) {
        return (
            <div className="manage-member-layout">
                <SideBar />
                <div className="product-details-main">
                    <DetailsHeaderBar
                        title="Subcategory Details"
                        subtitle="You can view the subcategory details"
                        breadcrumbs={[
                            {label: "Home", path: "/manage-member"},
                            {label: "Manage Subcategory", path: "/manage-subcategory"},
                            {label: "Subcategory Details" }
                        ]}
                    />
                    <div style={{textAlign: 'center', padding: '50px', color: '#d9534f'}}>
                        Subcategory not found.
                    </div>
                    <div style={{textAlign: 'center'}}>
                        <button 
                            onClick={() => navigate('/manage-subcategory')}
                            style={{
                                padding: '10px 20px',
                                background: '#007bff',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer'
                            }}
                        >
                            Back to Subcategories
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="manage-member-layout">
            <SideBar />
            <div className="product-details-main">
                <DetailsHeaderBar
                    title="Subcategory Details"
                    subtitle="You can view the subcategory details"
                    breadcrumbs={[
                        {label: "Home", path: "/manage-member"},
                        {label: "Manage Subcategory", path: "/manage-subcategory"},
                        {label: "Subcategory Details" }
                    ]}
                />

                <DetailSection
                    title="Subcategory Image"
                    icon={MdOutlineImage}
                    showEdit={true}
                    onEdit={goToEdit}
                    fields={[
                        {
                            label: "Image",
                            value: getProductImages().length > 0 ? (
                                <div style={{ display: "flex", gap: 10, marginTop: 6 }}>
                                {getProductImages().map((src, index) => (
                                    <img
                                    key={index}
                                    src={src}
                                    alt={`Subcategory ${index}`}
                                    onClick={() => setPreviewImage(src)}
                                    style={{
                                        height: 90,
                                        objectFit: "cover",
                                        borderRadius: 6,
                                        border: "1px solid #ddd",
                                        cursor: "pointer",
                                    }}
                                    />
                                ))}
                                </div>
                            ) : (
                                "No Image"
                            ),
                        }
                    ]}
                />

                <DetailSection
                    title="Basic Details"
                    icon={TbCategory}
                    onEdit={goToEdit}
                    fields={[
                        { label: "Subcategory name", value: subcategory.name },
                        { label: "Slug", value: subcategory.slug },
                        { 
                            label: "Status", 
                            value: (
                                <span style={{ 
                                    color: subcategory.status === 'active' ? '#28a745' : '#dc3545',
                                    fontWeight: 'bold'
                                }}>
                                    {subcategory.status.toUpperCase()}
                                </span>
                            ) 
                        },
                        { label: "Description", value: subcategory.description || "No description" },
                        { 
                            label: "Category", 
                            value: subcategory.category?.name || "Unknown",
                            subValue: `ID: ${subcategory.category_id}`
                        },
                        // { 
                        //     label: "Category Master", 
                        //     value: subcategory.category_master_name || "Not assigned",
                        //     subValue: subcategory.category_master_id ? `ID: ${subcategory.category_master_id}` : ""
                        // },
                        // { 
                        //     label: "Product Count", 
                        //     value: (
                        //         <span style={{ 
                        //             color: subcategory.product_count > 0 ? '#007bff' : '#6c757d',
                        //             fontWeight: 'bold'
                        //         }}>
                        //             {subcategory.product_count || 0} products
                        //         </span>
                        //     ) 
                        // },
                        { 
                            label: "Created By", 
                            value: subcategory.created_by_user?.name || "Unknown",
                            subValue: subcategory.created_by_user?.email ? `Email: ${subcategory.created_by_user.email}` : ""
                        },
                        { 
                            label: "Created At", 
                            value: new Date(subcategory.created_at).toLocaleDateString(),
                            subValue: new Date(subcategory.created_at).toLocaleTimeString()
                        },
                        { 
                            label: "Last Updated", 
                            value: new Date(subcategory.updated_at).toLocaleDateString(),
                            subValue: new Date(subcategory.updated_at).toLocaleTimeString()
                        },
                    ]}
                />
                
                {subcategory.meta_title || subcategory.meta_description || (subcategory.meta_keywords && subcategory.meta_keywords.length > 0) ? (
                    <DetailSection
                        title="SEO Information"
                        icon={TbCategory}
                        showEdit={false}
                        fields={[
                            { 
                                label: "Meta Title", 
                                value: subcategory.meta_title || "Not set",
                                style: { fontStyle: subcategory.meta_title ? 'normal' : 'italic', color: subcategory.meta_title ? '#000' : '#6c757d' }
                            },
                            { 
                                label: "Meta Description", 
                                value: subcategory.meta_description || "Not set",
                                style: { fontStyle: subcategory.meta_description ? 'normal' : 'italic', color: subcategory.meta_description ? '#000' : '#6c757d' }
                            },
                            { 
                                label: "Meta Keywords", 
                                value: subcategory.meta_keywords && subcategory.meta_keywords.length > 0
                                    ? Array.isArray(subcategory.meta_keywords) 
                                        ? subcategory.meta_keywords.join(", ")
                                        : String(subcategory.meta_keywords)
                                    : "Not set",
                                style: { fontStyle: subcategory.meta_keywords && subcategory.meta_keywords.length > 0 ? 'normal' : 'italic', color: subcategory.meta_keywords && subcategory.meta_keywords.length > 0 ? '#000' : '#6c757d' }
                            },
                        ]}
                    />
                ) : null}

                {previewImage && (
                    <div
                        onClick={() => setPreviewImage(null)}
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            background: "rgba(0,0,0,0.8)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            zIndex: 9999,
                        }}
                    >
                        <div style={{ position: "relative" }}>
                            <img
                                src={previewImage}
                                alt="Preview"
                                style={{
                                    maxWidth: "90vw",
                                    maxHeight: "90vh",
                                    borderRadius: 10,
                                }}
                            />

                            <button
                                onClick={() => setPreviewImage(null)}
                                style={{
                                    position: "absolute",
                                    top: -10,
                                    right: -10,
                                    background: "#e53935",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "50%",
                                    width: 30,
                                    height: 30,
                                    cursor: "pointer",
                                    fontSize: 16,
                                    fontWeight: "bold",
                                }}
                            >
                                ✕
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default SubCategoryDetails;
